(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-filter"] && !Shopify.designMode) return;
  try {
    const header = document.querySelector('header') 
    || document.querySelector('.header-wrapper')
    || document.querySelector('[id*="header"]');
  
  if (header) {
    const headerHeight = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }
  } catch(e) { console.error(e); }
})();

})();
